@use "Styles/mixins" as mixins;

$active-outline-inset: 3px;
$active-outline-border-radius: 10px;
$active-thumbnail-border-radius: $active-outline-border-radius - $active-outline-inset;

:host {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    gap: 8px;
    width: 169px;
    margin-top: $active-outline-inset;

    * {
        box-sizing: border-box;
    }

    .video-chapter-preview {
        position: relative;
        width: 80px;
        height: 45px;
        line-height: 0;

        &::after {
            content: "";
            position: absolute;
            inset: 0;
            opacity: 0.4;
            background-color: var(--vm-video-chapter-color, transparent);
            border-radius: $active-thumbnail-border-radius;
        }

        &__thumbnail {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: $active-thumbnail-border-radius;
        }

        &__duration {
            @include mixins.text-xs-medium();
            position: absolute;
            bottom: 4px;
            right: 4px;
            padding: 1px 8px 2px;
            border-radius: 10px;
            background-color: rgba(0, 0, 0, 0.7);
            backdrop-filter: blur(4px);
            color: mixins.get-color(text, text-white);
            z-index: 1;
            user-select: none;
        }
    }

    .video-chapter-title {
        @include mixins.text-xs-medium();
        color: mixins.get-color(text, text-primary);

        @include mixins.desktop-and-up() {
            color: mixins.get-color(text, text-primary-on-brand);
        }

        &__ordinal {
            @include mixins.text-xs-bold();
            color: inherit;
        }
    }
}

@mixin video-chapter-active-state {
    cursor: pointer;

    .video-chapter-preview::before {
        content: "";
        position: absolute;
        inset: -$active-outline-inset;
        border: 1.5px solid var(--vm-video-chapter-color, transparent);
        border-radius: $active-outline-border-radius;
    }
}

@media (hover: hover) {
    :host(:hover) {
        @include video-chapter-active-state;
    }
}

:host(.is-active),
:host(.is-hovered) {
    @include video-chapter-active-state;
}

@for $i from 1 through 5 {
    :host([data-color-index="#{$i}"]) {
        --vm-video-chapter-color: var(--video-chapter-color-#{$i});
    }
}
